/* ============================================================
   YOLÈTE — Boucles du dossier « Boucles détourées » présentes dans
   les books mais absentes du catalogue Shopify. Prix relevés dans
   les books (Annuel + Saisonnier) par lecture de la planche.
   Ces fiches disparaîtront d'ici toutes seules le jour où elles
   existeront dans Shopify (test sur le code + la largeur).
   ============================================================ */
(function () {
  if (typeof PRODUCTS === 'undefined' || typeof boucleBase !== 'function') return;
  var have = {};
  PRODUCTS.forEach(function (p) {
    if (p.type === 'boucle') have[(boucleBase(p) || '').toUpperCase() + '|' + p.width] = 1;
  });
  var ROWS = [
    ['N364', 25, 19.5],
    ['N366', 25, 19.5],
    ['N314B', 40, 79.0],
    ['N148', 25, 75.9],
    ['N255', 40, 169.9],
    ['N329', 40, 39.0],
    ['N348', 25, 89.9],
    ['N367', 25, 19.5],
    ['N371', 40, 29.0],
    ['N379', 25, 29.0],
    ['N384', 25, 47.0],
    ['N385', 25, 59.0],
    ['N386', 25, 65.0],
    ['N387', 25, 29.0],
    ['N388', 25, 29.9],
    ['N390', 40, 69.0],
    ['N391', 40, 75.0],
    ['N392', 40, 89.0],
    ['N393', 40, 29.9],
    ['N394', 40, 35.0],
    ['N395', 40, 29.9],
    ['N396', 40, 29.9],
    ['N397', 40, 39.9],
    ['N398', 40, 39.9],
    ['N399', 40, 29.9],
    ['N401', 40, 29.0],
    ['N402', 40, 99.9],
    ['N403', 40, 159.0],
    ['N404', 40, 169.0],
    ['N406', 40, 99.9],
    ['N407', 40, 129.0],
    ['N409', 40, 119.0],
    ['N410', 25, 89.9],
    ['N410', 40, 89.9],
    ['N413', 25, 89.0],
    ['N413', 40, 89.0],
    ['N414', 40, 59.0],
    ['N415', 25, 27.0],
    ['N416', 25, 29.0],
    /* Références du fichier « Dimensions et prix de vente » absentes de Shopify. */
    ['N325', 40, 99.50],
    ['N376', 40, 99.50],
    ['N417', 40, 69.00],
    ['N411', 25, 89.00],
    ['N412', 25, 79.90],
  ];
  ROWS.forEach(function (r) {
    var code = r[0], w = r[1], price = r[2];
    if (have[code + '|' + w]) return;                 // déjà au catalogue
    var id = 'boucle-' + code.toLowerCase() + (w === 25 ? '-25' : '');
    /* Le visuel par défaut vient des pastilles quand elles existent : toutes
       les boucles ne se déclinent pas en « gold », certaines n'ont qu'un
       coloris ou des noms de finition propres (Chorus, Valentine, Bordeaux). */
    var sw = (typeof BOUCLE_SWATCHES !== 'undefined')
      && (BOUCLE_SWATCHES[id] || BOUCLE_SWATCHES['boucle-' + code.toLowerCase()]);
    var img = (sw && sw.default_photo) ? String(sw.default_photo).split('?')[0]
            : 'https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles-site__' + id + '-gold.jpg';
    PRODUCTS.push({
      id: id, name: 'BOUCLE ' + code + (w === 25 ? '/25' : ''), type: 'boucle', width: w,
      style: null, audience: 'femme', price: price, img: img, images: [img], colors: [],
      descr: 'Boucle bijou interchangeable Yolète, compatible avec toutes nos tiges en ' + w + ' mm.'
    });
  });
})();
